import { Dispatch } from 'react';
import { IAction } from '../context/UseReportableDataContext';
import { ComparisonType, DashboardCurrency, DashboardDateRange, DashboardGranularity } from '../entities';

export function setBaseCurrencyAction(dispatch: Dispatch<IAction>, baseCurrency: DashboardCurrency) {
  dispatch({
    type: 'SET_BASE_CURRENCY',
    payload: { baseCurrency },
  });
  dispatch({
    type: 'UPDATE_QUERYSTRING',
  });
}

export function setComparisonAction(
  dispatch: Dispatch<IAction>,
  comparisonEnabled: boolean,
  comparisonType: ComparisonType,
  comparisonDateRange: DashboardDateRange,
  comparisonDateRangeOffset = 0,
) {
  dispatch({
    type: 'SET_COMPARISON',
    payload: {
      comparisonEnabled,
      comparisonType,
      comparisonDateRange,
      comparisonDateRangeOffset,
    },
  });
  dispatch({
    type: 'UPDATE_COMPARISON_DATE_TARGET',
  });
}

export function setGranularityAction(dispatch: Dispatch<IAction>, granularity: DashboardGranularity) {
  dispatch({
    type: 'SET_GRANULARITY',
    payload: { granularity },
  });
  dispatch({
    type: 'UPDATE_QUERYSTRING',
  });
}

export function updateQueryString(dispatch: Dispatch<IAction>) {
  dispatch({
    type: 'UPDATE_QUERYSTRING',
  });
}

export function setSalesTotalAction(dispatch: Dispatch<IAction>, salesTotals: any) {
  dispatch({
    type: 'SET_SALES_TOTALS',
    payload: { salesTotals },
  });
}

export function setComparisonSalesTotalAction(dispatch: Dispatch<IAction>, salesTotals: any) {
  dispatch({
    type: 'SET_COMPARISON_SALES_TOTALS',
    payload: { salesTotals },
  });
}

export function setLoadingAction(dispatch: Dispatch<IAction>, isLoading: boolean) {
  dispatch({
    type: 'SET_LOADING',
    payload: { isLoading },
  });
}
